import type { StyleRule } from '@archipro-design/aria';
import { pxToRem, pxArrayToRem } from '@archipro-design/aria';

export const VariantPurchase: StyleRule = ({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: 0,
    padding: pxArrayToRem([12, 18, 0, 18]),

    [theme.screen.min.tablet]: {
        padding: pxArrayToRem([24, 0, 0, 0]),
        gap: pxToRem(18),
        minHeight: pxToRem(212),
        gridTemplateColumns: '1fr 1fr',
        paddingTop: pxToRem(0),
        alignItems: 'center',
        borderBottom: `1px solid ${theme.siteVariables.colors.primitive.black}`,
    },
});
